import { Component, InjectionToken, Inject, HostListener, ChangeDetectionStrategy, Output, EventEmitter, OnDestroy } from '@angular/core';
import { MdlDialogReference } from '@angular-mdl/core';

export interface VideoDialogParameters {
    videoUrl: string;
    videoLoaded: () => void;
}

export const VIDEO_DIALOG_PARAMETERS = new InjectionToken<VideoDialogParameters>('VideoDialogParameters');

@Component({
    selector: 'app-play-video-dialog',
    template: require('./play-video-dialog.component.html'),
    styles: [require('./play-video-dialog.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlayVideoDialogComponent {
    @Output()
    public loadedData = new EventEmitter();

    constructor(
        private readonly dialog: MdlDialogReference,
        @Inject(VIDEO_DIALOG_PARAMETERS) public parameters: VideoDialogParameters
    ) { }

    @HostListener('document:keydown.esc')
    public close() {
        this.dialog.hide();
    }

    public onVideoLoaded() {
        if (this.parameters.videoLoaded) {
            this.parameters.videoLoaded();
        }
    }
}
